// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wft9","largestCol":"styles_largestCol__1BDLc","smallestCol":"styles_smallestCol__XfdZO"};